import axios from "axios";
import { API, GATE_KEY } from "./api";
import { SNAPSHOT, snapshotAdapter } from "./snapshot";

export const DELEGATE_KEY = "ciarb_delegate_session";

export const delegateApi = axios.create({ baseURL: API, ...(SNAPSHOT ? { adapter: snapshotAdapter } : {}) });
delegateApi.interceptors.request.use((config) => {
  const token = sessionStorage.getItem(DELEGATE_KEY);
  if (token) config.headers["X-Delegate-Session"] = token;
  const gate = localStorage.getItem(GATE_KEY); // /api/virtual/* is behind the site gate
  if (gate) config.headers["X-Site-Gate-Token"] = gate;
  return config;
});

export const denyMessage = (e) => {
  const d = e?.response?.data?.detail;
  if (d && typeof d === "object" && d.message) return d.message;
  return typeof d === "string" ? d : "Something went wrong. Please try again.";
};

const ZOOM_CDN = "https://source.zoom.us";
const loadScript = (src) => new Promise((resolve, reject) => {
  if (document.querySelector(`script[src="${src}"]`)) { resolve(); return; }
  const s = document.createElement("script");
  s.src = src; s.async = false; s.onload = resolve; s.onerror = () => reject(new Error(`Failed to load ${src}`));
  document.body.appendChild(s);
});

// Zoom Meeting SDK (component view) loaded from Zoom's CDN only on the join page; its React 18 vendor build stays isolated from the app bundle.
export async function loadZoomEmbedded(version) {
  if (window.__CIARB_ZOOM_MOCK__) return window.__CIARB_ZOOM_MOCK__; // headless state tests only (injected by the test runner)
  if (window.ZoomMtgEmbedded) return window.ZoomMtgEmbedded;
  for (const lib of ["react", "react-dom", "redux", "redux-thunk", "react-redux", "lodash"]) await loadScript(`${ZOOM_CDN}/${version}/lib/vendor/${lib}.min.js`);
  await loadScript(`${ZOOM_CDN}/zoom-meeting-embedded-${version}.min.js`);
  return window.ZoomMtgEmbedded;
}
